/**
 * @method: to call reducer
 */
 import { actionType } from "../header/action"; 
  const reducer = (state = {}, action) => {
     
    switch (action.type) {
      case actionType.GET_HEADER_REQUEST:
           return { ...state };
      case actionType.GET_HEADER_RECEIVED:
           return { ...state, ...action.payload}
      default: 
           return state;
    }
   };
   export default reducer;